/**
 * Main body for Enterprise Settings gear
 *
 * @prettier
 * @author Alexander Nagelberg
 * @since 23.5
 */
import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Authorize from 'app/components/Authorize'
import EnterpriseSettingsContainer from '../containers/EnterpriseSettingsContainer'

const EnterpriseSettingsBody = () => (
  <Authorize gearAuth={['View Enterprise Settings']} gearName='Enterprise Settings'>
    <Switch>
      <Route path='/lgyhub/admin/enterprise-settings' exact>
        <EnterpriseSettingsContainer />
      </Route>
    </Switch>
  </Authorize>
)

export default EnterpriseSettingsBody
